
import React, { useState, useEffect } from 'react';
import { MegaMenu } from 'primereact/megamenu';
import { Column } from 'primereact/column';
import { FilterMatchMode } from 'primereact/api';
import { ListOfSalesReportService as Service } from './ListOfSalesReportService';
import { DialogView } from '../../hoa-don/component/DialogView';
import { DialogSendEmail } from '../../hoa-don/component/DialogSendEmail';
import EventEmitter from '../../../utils/EventEmitter';
import { DataTable } from 'primereact/datatable';


import { FilterSale } from '../filter-sale';
import { FormatDisplay } from '../../../shared/format';
import { AppStorage } from '../../../service/UserStorage';

export default function Phuluc01() {

  const [displayFilter, setDisplayFilter] = useState(null);
  const [invoiceForm, setInvoiceForm] = useState(null);
  const [requiredParams, setRequiredParams] = useState(null);
  const [customers, setCustomers] = useState([]);
  const [filters, setFilters] = useState(null);
  const [displayView, setDisplayView] = useState(false);
  const [displaySendEmail, setDisplaySendEmail] = useState(false);
  const [invoiceStatus, setInvoiceStatus] = useState(0);
  const [displayCancel, setDisplayCancel] = useState(false);
  const [selectedItems, setselectedItems] = useState(null);

  const downloadExcel = () => {
    Service.downloadExcel({
      ...requiredParams,
      userName: AppStorage.get('UserName')
    }).then(data => {
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(new Blob([data]));
      link.download = `bang-ke-ban-ra-pl-01.xlsx`;
      link.click();
    });
  }
  useEffect(() => {
    const showDialogSendEmail = (dataInvoice) => {
      setselectedItems(dataInvoice);
      setDisplaySendEmail(true);
    };
    const eventsshowDialogSendEmail = EventEmitter.addListener("showDialogSendEmail", showDialogSendEmail);
    return () => {
      eventsshowDialogSendEmail.removeListener("showDialogSendEmail", showDialogSendEmail);
    }
  })
  const send = (item) => {
    item.id = item.invoiceId;
    setselectedItems(item);
    setDisplayView(true);
  }

  const search = (params) => {
    params.userName = AppStorage.get('UserName');
    Service.getList(params).then(data => setCustomers(data));
    setRequiredParams(params);
    setDisplayFilter(false);
  }

  const initFilters = () => {
    setFilters({
      'invoiceSerial': { value: null, matchMode: FilterMatchMode.CONTAINS },
    });

  }

  const actions = [
    { label: 'Lọc dữ liệu', icon: 'pi pi-fw pi-filter', className: 'iam-toolbar iam-toolbar-secondary', command: () => setDisplayFilter(true) },
    { label: 'Kết xuất excel', icon: 'pi pi-fw pi-file-excel', className: 'iam-toolbar iam-toolbar-secondary', command: downloadExcel }
  ];

  const headerTemplate = (data) => {
    return (
      <React.Fragment>
        <span style={{ textAlign: 'right', fontWeight: 'bold', fontStyle: 'italic' }}>{data.vatName}</span>
      </React.Fragment>
    );
  }

  const sumAmountWithoutVAT = (name) => {
    let total = 0;

    if (customers) {
      for (let customer of customers) {
        if (customer.tax.nameReport === name) {
          total = total + customer.amountWithoutVAT;
        }
      }
    }
    if (total === 0) return '0';
    return FormatDisplay.number(total, FormatDisplay.getFractionDigitsDefault(2));
  }

  const sumVATAmount = (name) => {
    let total = 0;

    if (customers) {
      for (let customer of customers) {
        if (customer.tax.nameReport === name) {
          total = total + customer.vatAmount;
        }
      }
    }
    if (total === 0) return '0';
    return FormatDisplay.number(total, FormatDisplay.getFractionDigitsDefault(2));
  }

  const footerTemplate = (data) => {
    return (
      <React.Fragment>
        <td colSpan={6} style={{ minWidth: '950px', fontWeight: 'bold' }}>Tổng cộng</td>
        <td style={{ width: '150px', textAlign: 'right', fontWeight: 'bold' }}>{sumAmountWithoutVAT(data.tax.nameReport)}</td>
        <td style={{ width: '150px', textAlign: 'right', fontWeight: 'bold' }}>{sumVATAmount(data.tax.nameReport)}</td>
        <td style={{ width: '100px' }}></td>
      </React.Fragment>
    );
  }

  const amountWithoutVATBodyTemplate = (rowData) => {
    return <span style={{ textAlign: 'left' }} >{FormatDisplay.number(rowData.amountWithoutVAT, FormatDisplay.getFractionDigitsDefault(2))}</span>;
  }
  const invoiceNumberTemplate = (rowData) => {
    return <span style={{ textAlign: 'left', cursor: 'pointer', textDecoration: 'underline', backgroundColor: '#cfe2f3', color: '#0000ff' }} onClick={() => send(rowData)} >{rowData.invoiceNumber}</span>;
  }

  const amountBodyTemplate = (rowData) => {
    return <span style={{ textAlign: 'left' }} >{FormatDisplay.number(rowData.vatAmount, FormatDisplay.getFractionDigitsDefault(2))}</span>;
  }


  const invoiceDateBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <span>{FormatDisplay.date(rowData.invoiceDate, 'DD/MM/YYYY')}</span>
      </React.Fragment>
    );
  }
  return (
    <React.Fragment>
      <MegaMenu model={actions} />
      <FilterSale header="Báo cáo bảng kê bán ra (PL01)" display={displayFilter} setDisplay={setDisplayFilter} search={search} invoiceForm={invoiceForm} />
      <div className="iam-data-table">
        <DataTable value={customers} rowGroupMode="subheader" groupRowsBy="tax.nameReport"
          sortMode="single" sortField="nameReport" showGridlines
          resizableColumns columnResizeMode="expand" scrollable scrollHeight="flex"
          rowGroupHeaderTemplate={headerTemplate} rowGroupFooterTemplate={footerTemplate} responsiveLayout="scroll">
          <Column field="ord" header="#" style={{ maxWidth: '50px' }}></Column>
          <Column field="invoiceSerial" filterField="invoiceSerial" header="Ký hiệu" style={{ maxWidth: '100px' }}></Column>
          <Column field="invoiceDate" header="Ngày hóa đơn" body={invoiceDateBodyTemplate} style={{ maxWidth: '120px' }}></Column>
          <Column field="invoiceNumber" body={invoiceNumberTemplate} header="Số hóa đơn" style={{ maxWidth: '100px' }}></Column>
          <Column field="buyerLegalName" header="Tên khách hàng" style={{ minWidth: '450px' }}></Column>
          <Column field="buyerTaxCode" header="Mã số thuế" style={{ maxWidth: '130px' }}></Column>
          <Column field="amountWithoutVAT" header="Tổng tiền trước thuế" body={amountWithoutVATBodyTemplate} style={{ width: '150px' }}></Column>
          <Column field="vatAmount" header="Tổng tiền thuế" body={amountBodyTemplate} style={{ width: '150px' }}></Column>
          <Column field="invoiceNote" header="Ghi chú" style={{ width: '100px' }}></Column>
        </DataTable>
      </div>
      <DialogView display={displayView} setDisplay={setDisplayView} selectedItem={selectedItems}
        setDisplayCancel={setDisplayCancel} setInvoiceStatus={setInvoiceStatus} />
      <DialogSendEmail display={displaySendEmail} setDisplay={setDisplaySendEmail} selectedItems={selectedItems} />
    </React.Fragment>
  );
}